import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import Pagination from '@mui/material/Pagination';

import swal from "sweetalert";
// materialui table
import MaterialTable from "@material-table/core";
import {
  Grid,
  TextField,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
  Card, CardContent, 
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

//import ReactExport from "react-data-export";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, Edit } from "@mui/icons-material";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";
import { getARVFacilityList } from "../../../services/Common";

import { format, isValid } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const Patients = (props) => {
  const permissionType = props.permissionType;

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const [selectedRow, setSelectedRow] = useState(null);
  const [numberRowPerPage, setNumberRowPerPage] = useState(15);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const [productsAllData, selectProductsAllData] = useState([]);
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );

  const lan = localStorage.getItem("LangCode");
  const menukey = "patients";
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");

  const [dataItems, setDataItems] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [search_data, setSearchData] = useState();


  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const [FacilityList, setFacilityList] = useState(getARVFacilityList());
  const isFacilityIdFound = FacilityList.some(facility => facility.id == FacilityId);
  const [currFacilityId, setCurrFacilityId] = useState(isFacilityIdFound ? FacilityId : "");


  const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }
    
     setCurrFacilityId(rowId);
  
  };
  
  
  React.useEffect(() => {
    localStorage.setItem(
      "FacilityId",
      currFacilityId
    );
  
   }, [currFacilityId]);

   
  let params = {
    action: "getPatientList",
    menukey: menukey,
    FacilityId: currFacilityId,
    page_limit: numberRowPerPage,
    page_number: pageNumber,
    searchData: "searchData",
    search_data: search_data,
  };
  const { error, isError, data, refetch } = useQuery(
    [params],
    api.getPatients,
    {
      onSuccess: (data) => {
        // localStorage.setItem("PatientDataNextPrev", JSON.stringify(data));

        setDataItems(data);
        setLoading(false);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  let params1 = {
    action: "getAllPatientList",
    menukey: menukey,
    FacilityId: currFacilityId,
    searchData: "searchData",
    search_data: search_data,
  };
  const {} = useQuery([params1], api.getAllPatients, {
    onSuccess: (data) => {
      localStorage.setItem("PatientDataNextPrev", JSON.stringify(data));
    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0, //1000 * 60 * 60 * 24,
  });

  const { mutate: deleteApi } = useMutation(api.deletePatient, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        refetch();
        queryClient.getQueriesData("patients");
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  const {
    error1,
    isError1,
    data: limitData,
    refetch: limitRefetch,
  } = useQuery(
    [
      {
        action: "getPatientTotal",
        menukey: menukey,
        FacilityId: currFacilityId,
        search_data: search_data,
      },
    ],
    api.getPatientTotal,
    {
      onSuccess: (data) => {
        setTotalRow(Math.ceil(data[0].TotalRow / numberRowPerPage));
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  function DateFormater(props: any) {
    const rowData = props.cell._cell.row.data;
    let date = new Date();
    switch (props.gridName) {
      case "patientData":
        date = rowData.registered;
        break;
      case "NextAppointmentDate":
        date = rowData.NextAppointmentDate;
        break;

      default:
        date = rowData.date;
        break;
    }
    return <>{format(new Date(date), 'd/MM/yyyy')}</>;
  }

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let currFacilityName=(FacilityList.find(Facility_List => Facility_List.id == currFacilityId) ?? null).name;


    window.open(
      finalUrl +
        "?action=PatientExcelExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now() +
        "&FacilityId=" +
        currFacilityId +
        "&FacilityName=" +
        currFacilityName
    );
  };
  /* =====End of Excel Export Code==== */

  function RowInputData(props, type = null) {
    const rowData = props.cell._cell.row.data;
    let fieldName = props.field;
    let fieldType = props.fieldType;
    // let labelName = props.labelName;
    // let dropDownKey = props.dropDownKey;

    switch (fieldType) {
      case "check-box":
        return rowData.type == "active" ? (
          <></>
        ) : (
          <Checkbox
            color="primary"
            checked={Boolean(Number(rowData[fieldName]))}
            name={fieldName}
            value={rowData[fieldName]}
          />
        );
        break;

      default:
        return <></>;
        break;
    }
    return <></>;
  }

  const tableRowDoubleClick = (e: any, row: any) => {
    let rowData = row._row.data;

    row._row.parent.rows.forEach((rowss, i) => {
      if (row._row.data.id == rowss.data.id) {
        localStorage.setItem("PatientDataIndex", JSON.stringify(i));

        editPatient(rowData);
        return;
      }
    });
  };

  let sl = 0;
  const columns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#."]),
      formatter: function (cell, formatterParams) {
        sl++;
        return (pageNumber - 1) * numberRowPerPage + sl;
      },
      hozAlign: "center",
      width: 80,
      //formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["ID Number"]),
      field: "idNumber",
      width: 150,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["PAS#"]),
      field: "pass",
      width: 150,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["IPN"]),
      field: "ipn",
      width: 150,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Last Name"]),
      field: "lastName",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["First Name"]),
      field: "firstName",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Contact#"]),
      width: 140,
      field: "contactNumber",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Gender"]),
      field: "gender",
      width: 120,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Registered"]),
      field: "registered",
      width: 140,
      formatter: reactFormatter(<DateFormater gridName="patientData" />),
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Last Appointment Date"]),
      field: "NextAppointmentDate",
      width: 140,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        let date = value ? new Date(value) : null;
        if (!date || !isValid(date)) {
          return "";
        }
        return format(date, 'dd/MM/yyyy');
      },
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Active"]),
      field: "active",
      hozAlign: "center",
      vertAlign: "middle",
      headerHozAlign: "center",
      width: 80,
      headerSort: false,

      formatter: reactFormatter(
        <RowInputData labelName="active" field="active" fieldType="check-box" />
      ),
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      hozAlign: "center",
      headerHozAlign: "center",
      width: 110,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const handleChange = (event, value) => {
    setPageNumber(value);
  };

  const handleChangePage = (data) => {
    //setPageNumber(data);
    // setFirstLoad(false);
  };
  const handleChangeRowPerPage = (data) => {
    //setNumberRowPerPage(data);
  };

  const editPatient = (data) => {
    let route = `patients/edit/${data.id}`;
    props.history.push(route);
  };

  const deletePatient = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Record!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteApi({
          PatientId: data.id,
          menukey: menukey,
          lan: lan,
          UserName: UserName,
          action: "deletePatient",
        });
      }
    });
  };

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (permissionType) {
      return <></>;
    } else {
      return (
        <>
          <Edit
            onClick={() => {
              dataItems.forEach((row, i) => {
                if (rowData.id == row.id) {
                  localStorage.setItem("PatientDataIndex", JSON.stringify(i));
                  editPatient(rowData);
                  return;
                }
              });
              // editPatient(rowData);
            }}
          />
          <DeleteOutline
            onClick={() => {
              deletePatient(rowData);
            }}
          />
        </>
      );
    }
  }

  const onSearch = (e) => {
    if (e.key === "Enter") {
      let searchString = e.target.value;
      setSearchData(searchString);
      setPageNumber(1);
      refetch();
    }
  };

  return (
    <>
      <div className={classes.patientPageTitle}>
        <div className="d-flex justify-patient mb-1">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {t(DispensingLanguage[lan][menukey]["Patient"])}
              </div>
            </div>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={2} sm={2}>
                <div className="sw_search">
                <TextField variant="standard"
                  id="search_data"
                  name="search_data"
                  label={t(DispensingLanguage[lan][menukey]["Search"])}
                  size="small"
                  autoComplete="family-name"
                  onKeyDown={(e) => onSearch(e)}
                />
              </div>
              </Grid>
              <Grid item xs={3} sm={3}>
                <FormControl className={classes.fullWidth}> 
                <Autocomplete
                      autoHighlight
                      className="sw_chosen_filter"
                      id="FacilityList"
                      disableClearable
                      disabled={IsAllFacility == 1 ? false : true}
                      options={FacilityList}
                      value={FacilityList.find((facility) => facility.id == currFacilityId) || null}
                      onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                      getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id ?? option.name}>
                          <Typography className="sw_fontSize">{option.name}</Typography>
                        </li>
                      )}
                      
                      renderInput={(params) => (
                      <TextField
                        {...params}
                          label={DispensingLanguage[lan][menukey]["Facility"]}
                        variant="standard"
                        hiddenLabel
                      />
                      )}
                    />

                </FormControl>
              </Grid> 

              <Grid item xs={7} sm={7}>
                <div className="float-end sw_btn_control">
                 
                 <Button
                  disabled={Boolean(permissionType)}
                  color="info"
                  className="me-2"
                  onClick={() => {
                    props.history.push("/patient-import");
                  }}
                >
                  {t(DispensingLanguage[lan][menukey]["Patient Import"])}
                </Button>

                 <Button
                  disabled={Boolean(permissionType)}
                  color="info"
                  className="me-2"
                  onClick={() => {
                    props.history.push("/patients/add");
                  }}
                >
                  {t(DispensingLanguage[lan][menukey]["Add Patient"])}
                </Button>

                <Button
                  color="info"
                  className="me-2 sw_icons"
                  onClick={() => PrintPDFExcelExportFunction("print")}
                >
                  <i className="fas fa-print"></i>
                </Button>

                <Button
                  color="info"
                  className="me-2 sw_icons"
                  onClick={() => PrintPDFExcelExportFunction("excel")}
                >
                  <i className="far fa-file-excel"></i>
                </Button>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>

          {/*height={500} */}

          <div className="marginTop20">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <Pagination
                  className="pull-right"
                  count={totalRow}
                  variant="outlined"
                  shape="rounded"
                  page={pageNumber}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};

export default Patients;

const useStyles = makeStyles({
  patientPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
